import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { FaArrowRight, FaArrowUp, FaTrash, FaPlus } from 'react-icons/fa';

import ReportAPI from '../../api/ReportAPI';
import MainCondition from '../settings/condition/MainCondition';
import AutomationModule from '../settings/automation/AutomationModule';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import FieldController from '../../controller/FieldController';
import Util from '../../util/Util';
import ApiUiController from '../../controller/ApiUiController';
import RegEx from '../../util/RegEx';
import ReportConst from '../../util/ReportConst';

import '../settings/Settings.css';

class ReportUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.state = {
      inApiCall: true, name: '',
      type: 0, view_type: 0,
      model: '', subModel: '',
      modelKey: '', subModelKey: '',
      xModel: '', yModel: '', zModel: '', x: '', y: '', z: '',
      filter: [], inValid: {},
      fields: []
    };
    this.models = reactLocalStorage.getObject(Const.Model);
    this.modelFields = [];
    this.subModelFields = [];
    this.modelConditionalFields = [];
    this.subModelConditionalFields = [];
    this.conditionsModel = [];
    this.conditionsSubModel = [];
    this.zFields = [];
    this.basePath = this.props.match.path;
    this.basePath = this.basePath.substring(0, this.basePath.indexOf('/add-edit'));
    this.report = {};
    this.Zaxis = [{ label: 'Count', value: 'COUNT' }, { label: 'Total/Sum', value: 'SUM' }];
  }

  componentDidMount() {
    if (this.id !== 0) {
      ReportAPI.get(this.id, this.onReceived, this.onFail);
    }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = report => {
    this.report = report;
    const model = report.model.includes(' ') ? report.model.split(' ') : [report.model];
    const subModel = report.sub_model && report.sub_model.includes(' ')
      ? report.sub_model.split(' ') : null;

    this.model = this.models[model[0]];
    this.subModel = subModel ? this.models[subModel[0]] : this.model;
    this.modelConditionalFields = FieldController.getFilterFields(this.model.fields);
    this.subModelConditionalFields = FieldController.getFilterFields(this.subModel.fields);
    this.modelFields = [];
    if (this.model.model_key === 'target') {
      this.modelFields = this.models[model[0]].options;
    } else {
      let keys = Object.keys(this.models[model[0]].fields);
      for (let i = 0; i < keys.length; i++) {
        this.modelFields.push({
          id: this.models[model[0]].fields[keys[i]].id,
          value: this.models[model[0]].fields[keys[i]].field_key,
          type: this.models[model[0]].fields[keys[i]].field_type,
          label: this.models[model[0]].fields[keys[i]].label_name
        });
      }
    }
    this.subModelFields = [];
    if (subModel) {
      let keys = Object.keys(this.models[subModel[0]].fields);
      for (let i = 0; i < keys.length; i++) {
        this.subModelFields.push({
          id: this.models[subModel[0]].fields[keys[i]].id,
          value: this.models[subModel[0]].fields[keys[i]].field_key,
          type: this.models[subModel[0]].fields[keys[i]].field_type,
          label: this.models[subModel[0]].fields[keys[i]].label_name
        });
      }
    } else {
      let keys = Object.keys(this.models[model[0]].fields);
      for (let i = 0; i < keys.length; i++) {
        this.subModelFields.push({
          id: this.models[model[0]].fields[keys[i]].id,
          value: this.models[model[0]].fields[keys[i]].field_key,
          type: this.models[model[0]].fields[keys[i]].field_type,
          label: this.models[model[0]].fields[keys[i]].label_name
        });
      }
    }

    const x = report.x && report.x.includes('.') ? report.x.split('.') : ['', report.x];
    const y = report.y && report.y.includes('.') ? report.y.split('.') : ['', report.y];

    let xModel;
    let yModel;
    if (!x[0] || !y[0]) {
      xModel = x ? this.models[model[0]].model_key : null;
      yModel = y ? this.models[model[0]].model_key : null;
    } else {
      xModel = x ? this.models[x[0] === model[1] ? model[0] : subModel[0]].model_key : null;
      yModel = y ? this.models[y[0] === model[1] ? model[0] : subModel[0]].model_key : null;
    }

    let conditions = [];
    try {
      conditions = JSON.parse(report.filter);
    } catch (err) {
      console.log(err);
    }
    this.conditionsModel = conditions.filter(condition => !condition.model_key
      || condition.model_key === model[0]);
    this.conditionsSubModel = subModel
      ? conditions.filter(condition => condition.model_key === subModel[0]) : [];

    const json = report.json ? JSON.parse(report.json) : {};

    let sum = '';
    try {
      sum = report.sum && report.sum.trim() ? report.sum : (report.z ? report.z
        : (subModel ? `COUNT(${model.substring(0, 1)}.id)` : `COUNT(id)`));
      if (!sum.includes('(')) {
        sum = `COUNT(${sum})`;
      }
      sum = sum.split('(')[1];
    } catch (err) {
      console.log(err);
    }

    const zValue = report.sum?.toUpperCase().includes('SUM') ? this.Zaxis[1].value : this.Zaxis[0].value;
    let zModel;
    if (sum && sum.includes('.')) {
      zModel = sum.substring(0, 1) === model[0].substring(0, 1) ? model[0] : subModel[0];
      sum = sum.split('.')[1];
    } else {
      zModel = model[0];
    }
    const z = sum.replace('.', '').replace(')', '');
    this.zFields = [];
    this.zFields.push({ id: 0, value: 'id', type: 'id', label: 'Id' });
    let keys = Object.keys(this.models[zModel].fields);
    for (let i = 0; i < keys.length; i++) {
      this.zFields.push({
        id: this.models[zModel].fields[keys[i]].id,
        value: this.models[zModel].fields[keys[i]].field_key,
        type: this.models[zModel].fields[keys[i]].field_type,
        label: this.models[zModel].fields[keys[i]].label_name
      });
    }

    this.setState({
      ...this.state,
      id: report.id,
      name: report.name,
      model: model[0],
      modelKey: model.length > 1 ? model[1] : null,
      subModel: subModel ? subModel[0] : null,
      subModelKey: subModel && subModel.length > 1 ? subModel[1] : null,
      type: report.type,
      view_type: report.view_type,
      xModel,
      yModel,
      zValue,
      zModel,
      x: x ? x[1] : null,
      y: y ? y[1] : null,
      z,
      ...json,
      inApiCall: false
    });

  };

  nameChange = event => this.setState({ ...this.state, name: event.target.value });
  onModelChange = (field, model) => {
    this.model = this.models[model];
    this.modelConditionalFields = [];
    this.modelConditionalFields = FieldController.getFilterFields(this.model.fields);
    this.modelFields = [];
    const keys = Object.keys(this.model.fields);
    for (let i = 0; i < keys.length; i++) {
      this.modelFields.push({
        id: this.model.fields[keys[i]].id,
        value: this.model.fields[keys[i]].field_key,
        type: this.model.fields[keys[i]].field_type,
        label: this.model.fields[keys[i]].label_name
      });
    }
    this.setState({ ...this.state, model: model });
  };
  onSubModelChange = (field, subModel) => {
    this.subModel = null;
    this.subModelFields = [];
    this.subModelConditionalFields = [];
    if (subModel) {
      this.subModel = this.models[subModel];
      this.subModelConditionalFields = FieldController.getFilterFields(this.subModel.fields);
      const keys = Object.keys(this.subModel.fields);
      for (let i = 0; i < keys.length; i++) {
        this.subModelFields.push({
          id: this.subModel.fields[keys[i]].id,
          value: this.subModel.fields[keys[i]].field_key,
          type: this.subModel.fields[keys[i]].field_type,
          label: this.subModel.fields[keys[i]].label_name
        });
      }
    }
    this.setState({ ...this.state, subModel: subModel });
  };
  onXModelChange = (field, model) => {
    const xModel = model;
    this.setState({ ...this.state, xModel });
  };
  onYModelChange = (field, model) => {
    const yModel = model;
    this.setState({ ...this.state, yModel });
  };
  onZModelChange = (field, model) => {
    const zModel = model;
    this.zFields = [];
    if (model) {
      this.zFields.push({ id: 0, value: 'id', type: 'id', label: 'Id' });
      const keys = Object.keys(this.models[model].fields);
      for (let i = 0; i < keys.length; i++) {
        this.zFields.push({
          id: this.models[model].fields[keys[i]].id,
          value: this.models[model].fields[keys[i]].field_key,
          type: this.models[model].fields[keys[i]].field_type,
          label: this.models[model].fields[keys[i]].label_name
        });
      }
    }
    this.setState({ ...this.state, zModel });
  };


  onFieldChange = (field, value) => {
    const state = { ...this.state };
    state[field] = value;
    this.setState({ ...state });
  };

  onModelConditionChange = conditions => this.conditionsModel = conditions;
  onSubModelConditionChange = conditions => this.conditionsSubModel = conditions;

  edit = conditions => this.conditions = conditions;

  onSave = () => {
    this.setState({ ...this.state, inApiCall: true });
    let report;
    if (this.state.subModel) {
      const modefilter = this.conditionsModel
        .filter(filter => Object.keys(filter).length !== 0 && filter && filter.field && filter.condition)
        .map(filter => {
          return {
            model_key: this.state.model, field: filter.field.value,
            type: filter.field.type, condition: filter.condition.value, value: filter.value
          };
        });
      const subModefilter = this.conditionsSubModel
        .filter(filter => Object.keys(filter).length !== 0 && filter && filter.field && filter.condition)
        .map(filter => {
          return {
            model_key: this.state.subModel, field: filter.field.value,
            type: filter.field.type, condition: filter.condition.value, value: filter.value
          };
        });
      const filter = JSON.stringify([...modefilter, ...subModefilter]);

      const json = JSON.stringify({ fields: [...this.state.fields] });

      const model = this.state.model + ' ' + this.state.model.substring(0, 1);
      const sub_model = this.state.subModel + ' ' + this.state.subModel.substring(0, 1);
      let x = '';
      if (this.state.x) {
        x = (this.state.model === this.state.xModel ? this.state.modelKey : this.state.subModelKey)
          + '.' + this.state.x;
      }
      let y = '';
      if (this.state.y) {
        y = (this.state.model === this.state.yModel ? this.state.modelKey : this.state.subModelKey)
          + '.' + this.state.y;
      }
      const z = this.state.z;
      let sum = '';
      try {
        sum = this.state.zValue + '(' + this.state.zModel.substring(0, 1) + '.' + this.state.z + ')';
      } catch (err) {
        console.log(err);
      }

      report = {
        id: this.state.id, name: this.state.name, type: this.state.type, view_type: this.state.view_type,
        model, sub_model, x, y, z, filter, json, sum
      };
    } else {
      const filter = this.conditionsModel.map(filter => {
        if (Object.keys(filter).length === 0) return {};
        else return {
          field: filter.field.value,
          type: filter.field.type, condition: filter.condition.value, value: filter ? filter.value : ''
        };
      });
      const sum = this.state.zValue + '(' + this.state.z + ')';
      report = {
        id: this.state.id, name: this.state.name, type: this.state.type, view_type: this.state.view_type,
        model: this.state.model, sub_model: null, x: this.state.x, y: this.state.y, z: this.state.z, filter: JSON.stringify(filter),
        json: null, sum
      };
    }
    ReportAPI.save(report, this.onSaved, this.onFail);
  };

  onSaved = () => {
    Util.showNotification('Successful', 'Successfully saved.', 'success');
    this.props.navigate(this.basePath);
  };
  onFieldAdd = () => {
    let fields = this.state.fields;
    if (!fields) {
      fields = [];
    }
    fields.push({});
    this.setState({ ...this.state, fields: [...fields] });
  };

  onFieldRemove = index => {
    let fields = [...this.state.fields];
    fields = fields.filter((_, i) => i !== index);
    this.setState({ ...this.state, fields: [...fields] });
  };

  render() {
    const inValid = this.state.inValid;
    return (
      <div className="sectionform pt-4">
        <div className="container-fluid form-cont">
          <div className="row"><div className="col-md-12 pb-3"><h3>Create Report</h3></div></div>

          <ApiUiController inApiCall={this.props.inApiCall}>
            <Form className="row lead-form">
              <div className="col-md-12">
                <div className="form-group">
                  <FormControl type='text' placeholder="Report Name"
                    className={`mr-sm-2 ${RegEx.class(inValid, 'name')} border`}
                    value={this.state.name} onChange={this.nameChange} />
                </div>
              </div>
            </Form>

            <Form className="row  lead-form">
              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Report Type</h4></div>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.Select}
                    onChange={() => this.onFieldChange('type', ReportConst.Select)} />
                  <Form.Check.Label>Only Select or MultiSelect Field</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.SelectToSelect}
                    onChange={() => this.onFieldChange('type', ReportConst.SelectToSelect)} />
                  <Form.Check.Label>2 Select or MultiSelect Field</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.SelectToHr
                    || this.state.type === ReportConst.SelectToHrDuplicate}
                    onChange={() => this.onFieldChange('type', ReportConst.SelectToHr)} />
                  <Form.Check.Label>Hourly Select or MultiSelect Field</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.SelectToDay
                    || this.state.type === ReportConst.SelectToTime}
                    onChange={() => this.onFieldChange('type', ReportConst.SelectToDay)} />
                  <Form.Check.Label>Daily Select or MultiSelect Field</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.SelectToMonth}
                    onChange={() => this.onFieldChange('type', ReportConst.SelectToMonth)} />
                  <Form.Check.Label>Monthly Select or MultiSelect Field</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.Consolidate}
                    onChange={() => this.onFieldChange('type', ReportConst.Consolidate)} />
                  <Form.Check.Label>Consolidated Report</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.Target}
                    onChange={() => this.onFieldChange('type', ReportConst.Target)} />
                  <Form.Check.Label>Target Report</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.ComplexSelect}
                    onChange={() => this.onFieldChange('type', ReportConst.ComplexSelect)} />
                  <Form.Check.Label>Complex only Select or Multiselect Field</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.ComplexSelectToSelect}
                    onChange={() => this.onFieldChange('type', ReportConst.ComplexSelectToSelect)} />
                  <Form.Check.Label>Complex 2 Select or Multiselect Field</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.None}
                    onChange={() => this.onFieldChange('type', ReportConst.None)} />
                  <Form.Check.Label>None</Form.Check.Label>
                </Form.Check>
              </div>

              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Report View</h4></div>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.List}
                    onChange={() => this.onFieldChange('view_type', ReportConst.List)} />
                  <Form.Check.Label>List</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.Table}
                    onChange={() => this.onFieldChange('view_type', ReportConst.Table)} />
                  <Form.Check.Label>Table</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.PieChart}
                    onChange={() => this.onFieldChange('view_type', ReportConst.PieChart)} />
                  <Form.Check.Label>Pie Chart</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.BarGraph}
                    onChange={() => this.onFieldChange('view_type', ReportConst.BarGraph)} />
                  <Form.Check.Label>Bar Graph</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.LineChart}
                    onChange={() => this.onFieldChange('view_type', ReportConst.LineChart)} />
                  <Form.Check.Label>Line Chart</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.MultiBarGraph}
                    onChange={() => this.onFieldChange('view_type', ReportConst.MultiBarGraph)} />
                  <Form.Check.Label>Multi Bar Graph</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.MultiLineChart}
                    onChange={() => this.onFieldChange('view_type', ReportConst.MultiLineChart)} />
                  <Form.Check.Label>Multi Line Chart</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.Funnel}
                    onChange={() => this.onFieldChange('view_type', ReportConst.Funnel)} />
                  <Form.Check.Label>Funnel</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.Gauge}
                    onChange={() => this.onFieldChange('view_type', ReportConst.Gauge)} />
                  <Form.Check.Label>Gauge</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.Download}
                    onChange={() => this.onFieldChange('view_type', ReportConst.Download)} />
                  <Form.Check.Label>Download</Form.Check.Label>
                </Form.Check>

              </div>
              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Module</h4></div>
                <AutomationModule onChange={this.onModelChange} model={this.state.model}
                  models={this.models} />
              </div>

              {(this.state.type === ReportConst.ComplexSelect || this.state.type === ReportConst.ComplexSelectToSelect) &&
                <div className="col-md-3">
                  <div className="formhead col-md-12"><h4>Sub Module</h4></div>
                  <AutomationModule onChange={this.onSubModelChange} model={this.state.subModel}
                    models={this.models} />
                </div>}

            </Form>

            <Form className="row  lead-form">
              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Rows </h4></div>
                <AutomationModule onChange={this.onXModelChange} model={this.state.xModel}
                  models={this.models} restricted={[this.state.model, this.state.subModel]} />
              </div>
              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Rows <FaArrowRight /></h4></div>
                <div className="condition-select col-md-12">
                  <Select
                    value={this.modelFields.find(field => field.value === this.state.x)}
                    className="mr-sm-2"
                    options={this.modelFields}
                    onChange={field => this.setState({ ...this.state, x: field ? field.value : '' })}
                    isSearchable={true} isClearable={true} />
                </div>
              </div>
              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Column</h4></div>
                <AutomationModule onChange={this.onYModelChange} model={this.state.yModel}
                  models={this.models} restricted={[this.state.model, this.state.subModel]} />
              </div>
              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Column <FaArrowUp /> </h4></div>
                <div className="condition-select col-md-12">
                  <Select
                    value={this.subModelFields?.find(field => field.value === this.state.y)}
                    className="mr-sm-2"
                    options={this.state.yModel === this.state.model ? this.modelFields
                      : this.state.yModel === this.state.subModel ? this.subModelFields
                        : []}
                    onChange={field => this.setState({ ...this.state, y: field ? field.value : '' })}
                    isSearchable={true} isClearable={true} />
                </div>
              </div>


              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Count / Sum</h4></div>
                <div className="condition-select col-md-12">
                  <Select
                    className="mr-sm-2"
                    value={this.Zaxis.find(field => field.value === this.state.zValue)}
                    options={this.Zaxis}
                    onChange={field => this.setState({ ...this.state, zValue: field ? field.value : '' })}
                    isSearchable={true} isClearable={true} />
                </div>
              </div>

              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Count / Sum Module</h4></div>
                <AutomationModule onChange={this.onZModelChange} model={this.state.zModel}
                  models={this.models} restricted={[this.state.model, this.state.subModel]} />
              </div>

              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Count / Sum Co-ordinate</h4></div>
                <div className="condition-select col-md-12">
                  <Select
                    value={this.zFields.find(field => field.value === this.state.z)}
                    onChange={field => this.setState({ ...this.state, z: field ? field.value : '' })}
                    className="mr-sm-2" options={this.zFields} isSearchable={true} isClearable={true} />
                </div>
              </div>

              {this.state.model
                ? <MainCondition model={this.model} fields={this.modelConditionalFields} value={this.conditionsModel}
                  title="Conditions" onConditionChanged={this.onModelConditionChange} />
                : null
              }
              {this.state.subModel
                ? <MainCondition title="Sub Model Condition"
                  model={this.subModel}
                  fields={this.subModelConditionalFields}
                  value={this.conditionsSubModel}
                  onConditionChanged={this.onSubModelConditionChange} />
                : null
              }
              {this.state.view_type === ReportConst.Download
                ? <>
                  <div className="row col-md-12 lead-form">
                    <div className="formhead col-md-12">
                      <h4>Fields <Button variant='primary' onClick={this.onFieldAdd}><FaPlus /></Button></h4>
                    </div>
                  </div>
                  {this.state.fields.map((field, i) =>
                    <Form className="row col-md-12 m-2 lead-form" key={`fields_${i + 1}`}>
                      <div className="col-md-1">
                        <AutomationModule
                          model={field.model}
                          models={this.models}
                          restricted={[this.state.model, this.state.subModel]}
                          onChange={(field, model) => {
                            const fields = [...this.state.fields];
                            fields[i].model = model;
                            this.setState({ ...this.state, fields: [...fields] });
                          }}
                        />
                      </div>

                      <div className="col-md-4">
                        <Select
                          value={(field.model === this.state.model ? this.modelFields
                            : field.model === this.state.subModel ? this.subModelFields
                              : [])
                            .find(innerField => innerField.value === field.field)
                          }
                          className="mr-sm-2"
                          options={field.model === this.state.model ? this.modelFields
                            : field.model === this.state.subModel ? this.subModelFields
                              : []
                          }
                          onChange={field => {
                            const fields = [...this.state.fields];
                            fields[i].field = field ? field.value : '';
                            this.setState({ ...this.state, fields: [...fields] });
                          }}
                          isSearchable={true} isClearable={true} />
                      </div>

                      <FaTrash onClick={() => this.onFieldRemove(i)} />
                    </Form>
                  )}
                </>
                : null
              }
              <div className="col-md-12 text-center btnsend m-3">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(ReportUpdate);